import { SET_SELECTED_DIVISIONS } from "./reducer";

export const setSelectedDivisions = (ids: number[]) => ({
  type: SET_SELECTED_DIVISIONS,
  ids,
});

export const resetApplicableProducts = () => ({
  type: "DISCOUNT/RESET_APPLICABLE_PRODUCTS",
});